import { __decorate } from "tslib";
import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import treeModel from '@blade-sxp/device-management/components/tree-model.vue';
import { deviceGroupsTree, editDeviceGroups, deviceGroups, deleteDeviceGroups, byExportGroup, } from '@blade-sxp/device-management/api/device-group-management/index';
import { likeAll } from '@blade-sxp/device-management/api/device-management/index';
import { debounce, includes } from 'lodash';
import EventBus from '@blade-sxp/device-management/utils/index';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import { getAllChilderId } from '@blade/common/utils/childer-tree-list';
let default_1 = class default_1 extends Vue {
    tree;
    nodeClick;
    currentKey;
    favoritesData = {
        id: 'favorites',
        name: `${this.$t('favorites')}`,
        type: 'favoritesBox',
        total: 0,
    };
    data = [];
    deviceParam = {};
    defaultProps = {
        children: 'children',
        lable: 'lable',
    };
    treeDialogVisible = false;
    fullSkDialogVisible = false;
    nodeExport = {};
    value = '';
    type = '';
    parentId = 0;
    deviceName = '';
    total = 0;
    deviceId = 0;
    loading = false;
    curNodeId = '';
    onInputDebounced = debounce(this.onInput, 200, { trailing: true });
    handleNodeClick(nodeItem) {
        this.curNodeId = String(nodeItem.id);
        this.nodeClick(nodeItem);
    }
    onInput(keyword) {
        this.$refs.tree?.filter(keyword);
    }
    filterNode(value, data) {
        if (!value)
            return true;
        return data.name.indexOf(value) !== -1;
    }
    onFilter(value, _, node) {
        return includes(node?.data?.name, value);
    }
    mounted() {
        this.getTree();
        EventBus.$on('addFavourites', (e) => {
            if (e) {
                this.getTree();
            }
        });
    }
    beforeDestroy() {
        EventBus.$off('addFavourites');
    }
    handleExport() {
        const id = Number(this.nodeExport.data.id);
        const groupIds = [...(getAllChilderId(this.nodeExport.data.id, this.data) || []), id];
        byExportGroup({ groupIds: groupIds }).then((res) => {
            window.location.href = res;
        });
    }
    exprotByFroupId(item) {
        this.fullSkDialogVisible = true;
        this.nodeExport = item;
    }
    getTree() {
        this.loading = true;
        deviceGroupsTree({
            excludeUngrouped: false,
        }).then((res) => {
            this.data = res.tree;
            // this.recursiveFunction(res.tree, 0);
            let unGrouped = res.tree.find((item) => {
                return item.name === 'Ungrouped Device';
            }) || {};
            let unGroupedIndex = res.tree.findIndex((item) => {
                return item.name === 'Ungrouped Device';
            });
            this.data.splice(unGroupedIndex, 1);
            this.data.push(unGrouped);
            this.data.unshift(this.favoritesData);
            likeAll()
                .then((res) => {
                this.favoritesData.total = Number(res.length);
                this.$refs.tree.setCurrentKey(this.data[1].id);
                this.nodeClick(this.data[1]);
            })
                .finally(() => {
                this.loading = false;
            });
        });
    }
    getOtherTree(isAdd) {
        this.loading = true;
        deviceGroupsTree({
            excludeUngrouped: false,
        }).then((res) => {
            this.data = res.tree;
            let unGrouped = res.tree.find((item) => {
                return item.name === 'Ungrouped Device';
            }) || {};
            let unGroupedIndex = res.tree.findIndex((item) => {
                return item.name === 'Ungrouped Device';
            });
            this.data.splice(unGroupedIndex, 1);
            this.data.push(unGrouped);
            this.data.unshift(this.favoritesData);
            likeAll()
                .then((res) => {
                this.favoritesData.total = Number(res.length);
                if (isAdd) {
                    const curNodeId = this.data[1].id;
                    this.$refs.tree.setCurrentKey(curNodeId);
                }
                else {
                    if (this.currentKey) {
                        this.$refs.tree.setCurrentKey(this.currentKey);
                    }
                    else {
                        const curNodeId = this.curNodeId ? this.curNodeId : this.data[1].id;
                        this.$refs.tree.setCurrentKey(curNodeId);
                    }
                }
            })
                .finally(() => {
                this.loading = false;
            });
        });
    }
    recursiveFunction(trees, i) {
        const getStr = function (list) {
            list.forEach(function (row) {
                i = i + 1;
                if (row.children) {
                    i = i + row.children.length;
                }
            });
        };
        getStr(trees);
    }
    getMaxFloor(trees) {
        // 获取树长度
        let max = 0;
        function each(data) {
            for (let i = 0; i < data.length; i++) {
                max++;
                if (data[i].children) {
                    each(data[i].children);
                }
            }
        }
        each(trees);
        return max;
    }
    onEdit(item) {
        this.treeDialogVisible = true;
        this.deviceName = item.data.name;
        this.deviceId = item.data.id;
        this.parentId = item.data.parentId;
        this.deviceParam = item.data;
        this.type = 'edit';
    }
    onAdd(item) {
        if (item.level >= 4) {
            this.$message({
                message: this.$t('cannotBeAdd'),
                type: 'warning',
            });
            return;
        }
        this.treeDialogVisible = true;
        this.deviceName = '';
        this.parentId = item.data.id;
        this.type = 'add';
    }
    eidtChange(name, model) {
        if (model) {
            deleteDeviceGroups(this.deviceId).then((res) => {
                this.$message({
                    message: `${this.$t('deletedSuccessfully')}`,
                    type: 'success',
                });
                this.getTree();
            });
            return;
        }
        if (this.type === 'edit') {
            editDeviceGroups({ name: name }, this.deviceId).then((res) => {
                this.$message({
                    message: `${this.$t('editDeviceGroups')}`,
                    type: 'success',
                });
                this.getTree();
            });
        }
        if (this.type === 'add') {
            let param = {
                parentId: this.parentId,
                name: name,
            };
            deviceGroups(param).then((res) => {
                this.$message({
                    message: `${this.$t('addDeviceSuccsuce')}`,
                    type: 'success',
                });
                this.getTree();
            });
        }
    }
};
__decorate([
    Ref()
], default_1.prototype, "tree", void 0);
__decorate([
    Prop()
], default_1.prototype, "nodeClick", void 0);
__decorate([
    Prop()
], default_1.prototype, "currentKey", void 0);
default_1 = __decorate([
    Component({
        name: 'leftTree',
        components: {
            treeModel,
            SecondaryVerification,
        },
        i18n: {
            messages: {
                en: {
                    devicesExportByGroup: 'Export the group of devices',
                    inputHolder: 'search',
                    favorites: 'Favorites',
                    deviceGroup: 'Device Group',
                    deletedSuccessfully: 'Deleted successfully',
                    cannotBeAdd: 'Device Group level maximum: 4',
                    ungroupedDevice: 'Ungrouped Device',
                    addDeviceSuccsuce: 'Device group added successfully',
                    editDeviceGroups: 'Device group modified successfully',
                    createALowerZone: 'Create a Lower Zone',
                    editTitle: 'Edit a Lower Zone',
                    createNewDevice: 'Create device group ',
                    editNewDevice: 'Edit device group',
                },
                zh: {
                    devicesExportByGroup: '导出设备组',
                    inputHolder: '搜索',
                    favorites: '收藏夹',
                    deviceGroup: '设备组',
                    deletedSuccessfully: '删除成功',
                    cannotBeAdd: '设备组层级不能超过4级',
                    ungroupedDevice: '未分组',
                    addDeviceSuccsuce: '添加设备组成功',
                    editDeviceGroups: '修改设备成功',
                    createALowerZone: '新建设备组',
                    editTitle: '编辑区域',
                    createNewDevice: '新建设备组',
                    editNewDevice: '编辑设备组',
                },
            },
        },
    })
], default_1);
export default default_1;
